import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft, Save } from 'lucide-react';
import api, { isAuthenticated } from '../utils/api';
import { toast } from 'sonner';

const AdminSettingsPage = () => {
  const [settings, setSettings] = useState({ ticker_text: '', video1_url: '', video2_url: '', video3_url: '' });
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated()) { navigate('/admin/login'); return; }
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const keys = ['ticker_text', 'video1_url', 'video2_url', 'video3_url'];
      const results = await Promise.all(keys.map(k => api.get(`/settings/${k}`)));
      const newSettings = {};
      keys.forEach((k, idx) => { newSettings[k] = results[idx].data.value || ''; });
      setSettings(newSettings);
    } catch (e) { console.error(e); }
  };

  const handleSave = async (key) => {
    try { await api.post('/settings', { key, value: settings[key] }); toast.success(`${key} updated!`); }
    catch (e) { toast.error('Error saving'); }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b sticky top-0 z-50">
        <div className="px-6 py-4 flex items-center space-x-4">
          <Link to="/admin/dashboard" className="text-[#E5A93C]"><ArrowLeft className="w-6 h-6" /></Link>
          <h1 className="font-heading text-xl font-bold text-[#2A0000]">Settings</h1>
        </div>
      </header>

      <div className="p-6 max-w-3xl space-y-6">
        <div className="bg-white rounded-lg border p-6">
          <h2 className="text-lg font-bold text-[#2A0000] mb-4">Announcement Ticker</h2>
          <textarea value={settings.ticker_text} onChange={(e) => setSettings({ ...settings, ticker_text: e.target.value })} rows={3} className="w-full px-4 py-2 border rounded" placeholder="Scrolling ticker text..." />
          <button onClick={() => handleSave('ticker_text')} className="mt-3 btn-primary flex items-center space-x-2"><Save className="w-4 h-4" /><span>Save</span></button>
        </div>

        <div className="bg-white rounded-lg border p-6">
          <h2 className="text-lg font-bold text-[#2A0000] mb-4">YouTube Video Embeds</h2>
          {['video1_url', 'video2_url', 'video3_url'].map((key, idx) => (
            <div key={key} className="mb-4">
              <label className="block text-sm font-medium mb-1">Video {idx + 1} URL</label>
              <div className="flex space-x-2">
                <input type="url" value={settings[key]} onChange={(e) => setSettings({ ...settings, [key]: e.target.value })} placeholder="https://www.youtube.com/embed/..." className="flex-1 px-4 py-2 border rounded" />
                <button onClick={() => handleSave(key)} className="btn-primary px-4 py-2"><Save className="w-4 h-4" /></button>
              </div>
            </div>
          ))}
          <p className="text-sm text-gray-600 mt-2">Use YouTube embed URLs (https://www.youtube.com/embed/VIDEO_ID)</p>
        </div>

        <div className="bg-white rounded-lg border p-6">
          <h2 className="text-lg font-bold text-[#2A0000] mb-4">Admin Credentials</h2>
          <div className="bg-gray-50 p-3 rounded font-mono text-sm">
            Username: <strong>admin</strong><br />
            Password: <strong>admin123</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSettingsPage;
